import { FC } from 'react'

type ProductShippingDateProps = {
  date?: string
}

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  })
}

export const ProductShippingDate = (props) => {
  const { date } = props
  if (!date) return null

  return (
    <div className="mb-20 rounded-8 bg-[rgba(212,212,212,0.75)] px-14 py-10 text-11 font-medium uppercase text-darkerGray">
      Shipping starts {formatDate(date)}
    </div>
  )
}
